import { Injectable } from "@angular/core";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { BaseJWTService, PUBLIC_IN_PRACTICE_JWT_STORAGE_KEY } from "projects/core/app/services/abstracts/jwt.service";
import { isOnUnsupportedPage } from "projects/core/app/utils/unsupported";

dayjs.extend(advancedFormat);

@Injectable({
  providedIn: "root",
})
export class ConciergeJWTService extends BaseJWTService {
  public get isRestricted(): boolean {
    return false;
  }

  public handleInvalidToken(reload = true): null {
    this.onInvalidJWT.next();

    if (this.isPublicInPractice(this.accessLevel)) {
      this._cacheService.clearSession();
      this._cacheService.clear();
    } else if (this.isPatientInPractice()) {
      this.restorePublicInPracticeToken();
    }

    if (reload && !isOnUnsupportedPage()) this._windowService.open("/");
    return null;
  }

  /**
   * Renames the current (portal in practice) jwt and replaces it with the patient in practice jwt
   */
  public loginPatientInPractice(token: string) {
    this.setToken(token);
  }

  public setToken(jwt: string) {
    super.setToken(jwt);

    if (this.isPublicInPractice(this._jwtParsed?.access_level)) {
      this._cacheService.set(PUBLIC_IN_PRACTICE_JWT_STORAGE_KEY, jwt);
    }
  }
}
